import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSEO } from '@/hooks/useSEO';

export default function NotFound() {
  const location = useLocation();
  useSEO('页面不存在-韩漫网址', '抱歉，你访问的页面不存在或已被移除，请返回韩漫网址首页继续浏览。');

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <h1 className="mt-5 text-3xl font-bold text-foreground-950 md:text-5xl">404</h1>
        <p className="mt-3 text-base font-medium text-foreground-800">页面不存在</p>
        <p className="mt-1 break-all text-sm text-foreground-500">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
          >
            浏览全部漫画
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}